import { C } from '../config';

function AgentStatusPanel() {
  const [brightreeStatus, setBrightreeStatus] = useState("idle"); // idle | running | done | error
  const [airviewStatus,   setAirviewStatus]   = useState("idle");
  const [btLog,           setBtLog]           = useState([]);
  const [avLog,           setAvLog]           = useState([]);

  const runBrightreeAgent = async () => {
    setBrightreeStatus("running");
    setBtLog(["🔐 Logging in as agent.notes@sleepmetrics.com…"]);
    await new Promise(r=>setTimeout(r,1200));
    setBtLog(p=>[...p,"🔍 Searching for patient: Jefferson Abaricia…"]);
    await new Promise(r=>setTimeout(r,900));
    setBtLog(p=>[...p,"📂 Opening patient file…"]);
    await new Promise(r=>setTimeout(r,800));
    setBtLog(p=>[...p,"📋 Navigating to Notes section…"]);
    await new Promise(r=>setTimeout(r,700));
    setBtLog(p=>[...p,"✍️ Pasting contact note…"]);
    await new Promise(r=>setTimeout(r,600));
    setBtLog(p=>[...p,"💾 Saving note…"]);
    await new Promise(r=>setTimeout(r,500));
    setBtLog(p=>[...p,"✅ Note saved successfully in Brightree."]);
    setBrightreeStatus("done");
  };

  const runAirviewAgent = async () => {
    setAirviewStatus("running");
    setAvLog(["🔐 Logging in to AirView as agent account…"]);
    await new Promise(r=>setTimeout(r,1200));
    setAvLog(p=>[...p,"📊 Navigating to Compliance Exports…"]);
    await new Promise(r=>setTimeout(r,900));
    setAvLog(p=>[...p,"⚙️ Triggering export: Status Active, all patients…"]);
    await new Promise(r=>setTimeout(r,1100));
    setAvLog(p=>[...p,"⏳ Waiting for export to generate…"]);
    await new Promise(r=>setTimeout(r,2000));
    setAvLog(p=>[...p,"⬇️ Downloading Compliance_report_20260303.xlsx…"]);
    await new Promise(r=>setTimeout(r,800));
    setAvLog(p=>[...p,"🔄 Parsing report — 4,771 patients found…"]);
    await new Promise(r=>setTimeout(r,600));
    setAvLog(p=>[...p,"📋 Updating dashboard lists A, B, C…"]);
    await new Promise(r=>setTimeout(r,500));
    setAvLog(p=>[...p,"✅ Dashboard refreshed. Next run: tomorrow 7:00 AM."]);
    setAirviewStatus("done");
  };

  const statusColor = (s) => s==="done" ? C.green : s==="running" ? C.orange : s==="error" ? C.red : C.muted;
  const statusLabel = (s) => s==="done" ? "Last run: success" : s==="running" ? "Running…" : s==="error" ? "Last run: failed" : "Idle";

  return (
    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>
      {/* Brightree Agent */}
      <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, overflow:"hidden" }}>
        <div style={{ padding:"14px 18px", borderBottom:`1px solid ${C.border}`, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <div>
            <div style={{ fontSize:13, fontWeight:800, color:C.text }}>🏥 Brightree Note Agent</div>
            <div style={{ fontSize:11, color:C.muted, marginTop:2 }}>Logs in as agent.notes@sleepmetrics.com · Creates patient notes</div>
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
            <div style={{ width:7, height:7, borderRadius:"50%", background:statusColor(brightreeStatus) }} />
            <span style={{ fontSize:11, color:statusColor(brightreeStatus), fontWeight:600 }}>{statusLabel(brightreeStatus)}</span>
          </div>
        </div>
        <div style={{ padding:"14px 18px" }}>
          <div style={{ fontSize:11, color:C.muted, marginBottom:10 }}>
            Triggered automatically after a coach logs a contact and confirms. Can also be run manually below.
          </div>
          {btLog.length > 0 && (
            <div style={{ background:"#EEF0F7", border:`1px solid ${C.border}`, borderRadius:7, padding:"10px 12px", marginBottom:12, maxHeight:140, overflowY:"auto" }}>
              {btLog.map((line,i) => <div key={i} style={{ fontSize:11, color:C.muted, fontFamily:"'IBM Plex Mono',monospace", marginBottom:3, lineHeight:1.5 }}>{line}</div>)}
            </div>
          )}
          <button
            onClick={runBrightreeAgent}
            disabled={brightreeStatus==="running"}
            style={{
              background: brightreeStatus==="running" ? C.orange+"18" : C.teal+"14",
              border:`1px solid ${brightreeStatus==="running" ? C.orange+"40" : C.teal+"30"}`,
              color: brightreeStatus==="running" ? C.orange : C.teal,
              borderRadius:7, padding:"8px 16px", fontSize:12, fontWeight:700,
              cursor: brightreeStatus==="running" ? "wait" : "pointer", fontFamily:"inherit",
            }}
          >{brightreeStatus==="running" ? "Running…" : brightreeStatus==="done" ? "Run Again" : "Test Run"}</button>
        </div>
      </div>

      {/* AirView Agent */}
      <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, overflow:"hidden" }}>
        <div style={{ padding:"14px 18px", borderBottom:`1px solid ${C.border}`, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <div>
            <div style={{ fontSize:11, fontWeight:800, color:C.text }}>AirView Download Agent</div>
            <div style={{ fontSize:11, color:C.muted, marginTop:2 }}>Runs daily at 7:00 AM · Downloads compliance export · Updates dashboard</div>
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
            <div style={{ width:7, height:7, borderRadius:"50%", background:statusColor(airviewStatus) }} />
            <span style={{ fontSize:11, color:statusColor(airviewStatus), fontWeight:600 }}>{statusLabel(airviewStatus)}</span>
          </div>
        </div>
        <div style={{ padding:"14px 18px" }}>
          <div style={{ fontSize:11, color:C.muted, marginBottom:10 }}>
            Logs into AirView, triggers all-active compliance export, parses report, and refreshes Lists A, B, C automatically.
          </div>
          {avLog.length > 0 && (
            <div style={{ background:"#EEF0F7", border:`1px solid ${C.border}`, borderRadius:7, padding:"10px 12px", marginBottom:12, maxHeight:140, overflowY:"auto" }}>
              {avLog.map((line,i) => <div key={i} style={{ fontSize:11, color:C.muted, fontFamily:"'IBM Plex Mono',monospace", marginBottom:3, lineHeight:1.5 }}>{line}</div>)}
            </div>
          )}
          <button
            onClick={runAirviewAgent}
            disabled={airviewStatus==="running"}
            style={{
              background: airviewStatus==="running" ? C.orange+"18" : C.blue+"12",
              border:`1px solid ${airviewStatus==="running" ? C.orange+"40" : C.blue+"28"}`,
              color: airviewStatus==="running" ? C.orange : C.blue,
              borderRadius:7, padding:"8px 16px", fontSize:12, fontWeight:700,
              cursor: airviewStatus==="running" ? "wait" : "pointer", fontFamily:"inherit",
            }}
          >{airviewStatus==="running" ? "Running…" : airviewStatus==="done" ? "Run Again" : "Run Now"}</button>
        </div>
      </div>
    </div>
  );
}

export default AgentStatusPanel;
